import { Directive, Renderer2, ElementRef, DoCheck, Input } from '@angular/core';

@Directive({
    selector: '[appCustomMenuItemTooltip]'
})
export class CustomMenuItemTooltipDirective implements DoCheck {

    @Input() options: any[];
    constructor(private renderer: Renderer2, private elementRef: ElementRef) { }

    ngDoCheck(): void {
        const element = this.elementRef.nativeElement;
        const links = element.getElementsByClassName('p-menuitem-link');

        if (links.length > 0) {
            for (let i = 0; i < links.length; i++) {
                const tooltipText = links[i].getElementsByClassName('p-tooltip-content');
                if (this.options.length > 0 && this.options[i].showTooltip && !tooltipText[0]) {
                    const span = this.renderer.createElement('span');
                    const tooltip = this.renderer.createText(this.options[i].tooltip);

                    this.renderer.addClass(span, 'p-tooltip-content');
                    this.renderer.appendChild(span, tooltip);
                    this.renderer.appendChild(links[i], span);
                    this.renderer.addClass(links[i], 'p-tooltip-custom');
                    this.renderer.addClass(links[i], 'p-tooltip-bottom');
                } else if (this.options.length > 0 && this.options[i].targetBlank) {
                    this.renderer.removeAttribute(links[i], 'target');
                }
            }
        }
    }
}
